/* Not loaded on the storefront: the theme loads esp-quote-accessibility.min.js, a copy of this file. Shopify re-minifies .js assets into syntax iOS 13.0-13.3 cannot run, and serves .min.js files as they are. Make changes in esp-quote-accessibility.min.js. */
(() => {
  'use strict';

  if (window.__espQuoteAccessibility) return;
  window.__espQuoteAccessibility = true;

  // Enhance the app's observed DOM without replacing its click, validation,
  // quantity, removal or submission handlers.
  const openerSelector = '.wfq-quote-btn-default,.wfq-quote-btn-selected,.wfq-header-icon';
  const actionSelector = `${openerSelector},.wfq-close,.wfq-deleteIcon,.wfq-qty-minus,.wfq-qty-plus,.wfq-selected-country,.wfq-country-option`;
  const focusSelector = 'a[href],button,input,select,textarea,[tabindex]';
  const strings = (key, fallback, values = {}) => {
    var _window$espAccessibil;
    const value = (_window$espAccessibil = window.espAccessibilityStrings) === null || _window$espAccessibil === void 0 ? void 0 : _window$espAccessibil[key];
    return (typeof value === 'string' && value.trim() ? value : fallback).replace(/\{(\w+)\}/g, (token, name) => values[name] == null ? token : String(values[name]));
  };
  const set = (element, name, value) => {
    if (element.getAttribute(name) !== String(value)) element.setAttribute(name, value);
  };
  const visible = element => {
    if (!(element !== null && element !== void 0 && element.isConnected) || element.closest('[hidden],[inert]') || !element.getClientRects().length) return false;
    for (let current = element; current; current = current.parentElement) {
      const style = getComputedStyle(current);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return false;
    }
    return true;
  };
  const focusable = root => [...root.querySelectorAll(focusSelector)].filter(element => visible(element) && !element.disabled && element.getAttribute('aria-disabled') !== 'true' && element.tabIndex >= 0);
  const makeButton = (element, name) => {
    if (!element.matches('button,a[href],input')) {
      set(element, 'role', 'button');
      set(element, 'tabindex', element.getAttribute('aria-disabled') === 'true' ? '-1' : '0');
    }
    if (name) set(element, 'aria-label', name);
  };
  const rowName = row => {
    var _row$querySelector;
    return (row === null || row === void 0 || (_row$querySelector = row.querySelector('.wfq-title')) === null || _row$querySelector === void 0 ? void 0 : _row$querySelector.textContent.trim()) || strings('quoteProduct', 'product');
  };
  const productName = element => rowName(element.closest('.wfq-pro-info'));
  let modal = null;
  let opener = null;
  let open = false;
  let queued = false;
  let focusRecord = null;
  let pendingCountry = null;
  let quoteState = null;
  let errorState = null;
  let validationUntil = 0;
  let uniqueId = 0;
  let redirecting = false;
  const background = new Map();
  const ownErrorIds = new WeakMap();
  const ownInvalid = new WeakMap();
  const ensureId = (element, prefix) => {
    if (!element.id) {
      let id;
      do {
        id = `esp-quote-${prefix}-${++uniqueId}`;
      } while (document.getElementById(id));
      element.id = id;
    }
    return element.id;
  };
  const releaseBackground = () => {
    background.forEach((wasInert, element) => {
      if (!wasInert) element.removeAttribute('inert');
    });
    background.clear();
  };
  const lockBackground = () => {
    for (let branch = modal; (_branch = branch) !== null && _branch !== void 0 && _branch.parentElement && branch !== document.body; branch = branch.parentElement) {
      var _branch;
      [...branch.parentElement.children].forEach(sibling => {
        if (sibling === branch || ['SCRIPT', 'STYLE', 'LINK'].includes(sibling.tagName)) return;
        if (!background.has(sibling)) background.set(sibling, sibling.hasAttribute('inert'));
        if (!sibling.hasAttribute('inert')) sibling.setAttribute('inert', '');
      });
    }
  };
  const focus = element => {
    if (visible(element)) element.focus();
  };
  const release = () => {
    var _modal;
    releaseBackground();
    document.body.classList.remove('esp-quote-open');
    (_modal = modal) === null || _modal === void 0 || _modal.removeAttribute('aria-modal');
    open = false;
    focusRecord = null;
    pendingCountry = null;
    quoteState = null;
    errorState = null;
    validationUntil = 0;
    const target = visible(opener) ? opener : [...document.querySelectorAll(openerSelector)].find(visible);
    focus(target);
    opener = null;
  };
  const rememberFocus = element => {
    const row = element.closest('.wfq-pro-info');
    focusRecord = {
      element,
      id: element.id,
      name: element.getAttribute('name'),
      label: element.getAttribute('aria-label'),
      rowName: row && rowName(row),
      rowIndex: row ? [...modal.querySelectorAll('.wfq-pro-info')].indexOf(row) : -1,
      action: ['wfq-quant-update', 'wfq-qty-minus', 'wfq-qty-plus', 'wfq-deleteIcon'].find(name => element.classList.contains(name))
    };
  };
  const replacementFocus = () => {
    if (!focusRecord) return null;
    if (visible(focusRecord.element) && modal.contains(focusRecord.element)) return focusRecord.element;
    const candidates = focusable(modal);
    const byId = focusRecord.id && candidates.find(element => element.id === focusRecord.id);
    if (byId) return byId;
    if (focusRecord.action) {
      const rows = [...modal.querySelectorAll('.wfq-pro-info')];
      const samePosition = rows[focusRecord.rowIndex];
      const row = samePosition && rowName(samePosition) === focusRecord.rowName ? samePosition : rows.find(candidate => rowName(candidate) === focusRecord.rowName);
      if (row) return row.querySelector(`.${focusRecord.action}`);
      // A removed row yields to the next remaining row, then the preceding row.
      const neighbor = rows[Math.min(focusRecord.rowIndex, rows.length - 1)];
      return (neighbor === null || neighbor === void 0 ? void 0 : neighbor.querySelector('.wfq-quant-update')) || (neighbor === null || neighbor === void 0 ? void 0 : neighbor.querySelector('.wfq-deleteIcon'));
    }
    return candidates.find(element => focusRecord.name && element.getAttribute('name') === focusRecord.name) || candidates.find(element => focusRecord.label && element.getAttribute('aria-label') === focusRecord.label);
  };
  const liveRegion = (kind, role) => {
    let region = modal.querySelector(`[data-esp-quote-${kind}]`);
    if (!region) {
      region = document.createElement('div');
      region.setAttribute(`data-esp-quote-${kind}`, '');
      region.className = 'esp-quote-sr-only';
      region.setAttribute('role', role);
      region.setAttribute('aria-atomic', 'true');
      region.setAttribute('aria-live', role === 'alert' ? 'assertive' : 'polite');
      modal.append(region);
    }
    return region;
  };
  const announce = (region, message, repeat = false) => {
    if (region.textContent === message) {
      if (!repeat) return;
      region.textContent = '';
      requestAnimationFrame(() => {
        if (open && region.isConnected) region.textContent = message;
      });
    } else region.textContent = message;
  };
  const autocomplete = {
    name: 'name',
    email: 'email',
    firstName: 'given-name',
    lastName: 'family-name',
    company: 'organization',
    phone: 'tel-national',
    address1: 'address-line1',
    address2: 'address-line2',
    city: 'address-level2',
    country: 'country-name',
    province: 'address-level1',
    zip: 'postal-code'
  };
  const setInvalid = (element, invalid) => {
    if (invalid) {
      if (!ownInvalid.has(element)) ownInvalid.set(element, element.getAttribute('aria-invalid'));
      set(element, 'aria-invalid', 'true');
    } else if (ownInvalid.has(element)) {
      const previous = ownInvalid.get(element);
      if (previous == null) element.removeAttribute('aria-invalid');else set(element, 'aria-invalid', previous);
      ownInvalid.delete(element);
    }
  };
  const phoneCaptionIds = label => {
    // The app can wrap the country picker and textbox in the same label. Give
    // the textbox only the visible caption, leaving all vendor controls in place.
    [...label.childNodes].forEach(node => {
      if (node.nodeType !== Node.TEXT_NODE || !node.textContent.trim()) return;
      const caption = document.createElement('span');
      caption.setAttribute('data-esp-quote-phone-label', '');
      label.insertBefore(caption, node);
      caption.append(node);
    });
    let captions = [...label.children].filter(element => element.hasAttribute('data-esp-quote-phone-label'));
    if (!captions.length) {
      const controls = 'input,select,textarea,button,.wfq-custom-dropdown,.wfq-selected-country,.wfq-dropdown-list';
      captions = [...label.children].filter(element => !element.matches(controls) && !element.querySelector(controls) && !element.closest('[hidden],[aria-hidden="true"]') && /\p{L}/u.test(element.textContent));
    }
    return captions.map(caption => ensureId(caption, 'phone-label')).join(' ');
  };
  const enhanceFields = () => {
    modal.querySelectorAll('input,select,textarea').forEach(element => {
      var _element$name;
      if (element.matches('[type="hidden"],[type="submit"],[type="button"]') || element.closest('.wfq-dropdown-list')) return;
      const key = (element.name || '').replace(/^billing_/, '');
      const billing = (_element$name = element.name) === null || _element$name === void 0 ? void 0 : _element$name.startsWith('billing_');
      if (autocomplete[key] && (!element.autocomplete || /^(off|on)$/i.test(element.autocomplete))) {
        set(element, 'autocomplete', `${billing ? 'billing ' : ''}${autocomplete[key]}`);
      }
      const field = element.closest('.selected-field');
      if (key === 'phone') {
        ensureId(element, 'phone');
        const label = field === null || field === void 0 ? void 0 : field.querySelector('label');
        if (label) {
          // Vendor labels incorrectly target the nested country-search input.
          set(label, 'for', element.id);
          const captionIds = phoneCaptionIds(label);
          if (captionIds) set(element, 'aria-labelledby', captionIds);else set(element, 'aria-label', billing ? strings('quoteBillingPhone', 'Billing phone') : strings('quotePhone', 'Phone'));
        } else if (!element.getAttribute('aria-labelledby')) {
          set(element, 'aria-label', billing ? strings('quoteBillingPhone', 'Billing phone') : strings('quotePhone', 'Phone'));
        }
        set(element, 'inputmode', 'tel');
      }
      const errors = field ? [...field.querySelectorAll(':scope > .wfq-form-error')].filter(error => visible(error) && error.textContent.trim()) : [];
      const previousIds = ownErrorIds.get(element) || [];
      const ids = new Set((element.getAttribute('aria-describedby') || '').split(/\s+/).filter(id => id && !previousIds.includes(id)));
      const errorIds = errors.map(error => ensureId(error, 'error'));
      errorIds.forEach(id => ids.add(id));
      ownErrorIds.set(element, errorIds);
      if (ids.size) set(element, 'aria-describedby', [...ids].join(' '));else element.removeAttribute('aria-describedby');
      setInvalid(element, !!errors.length || ownInvalid.has(element) && element.validity && !element.validity.valid);
    });
  };
  const enhanceCountries = () => {
    modal.querySelectorAll('.wfq-custom-dropdown').forEach(dropdown => {
      const trigger = dropdown.querySelector('.wfq-selected-country');
      const list = dropdown.querySelector('.wfq-dropdown-list');
      if (!trigger || !list) return;
      const expanded = visible(list);
      makeButton(trigger, strings('quotePhoneCode', 'Phone country code {code}', {
        code: trigger.textContent.replace('▼', '').trim()
      }));
      set(trigger, 'aria-expanded', expanded);
      set(trigger, 'aria-controls', ensureId(list, 'countries'));
      const search = list.querySelector('input');
      if (search) set(search, 'aria-label', strings('quoteSearchPhoneCodes', 'Search phone country codes'));
      const options = [...list.querySelectorAll('.wfq-country-option')];
      const candidates = options.filter(visible);
      const current = candidates.includes(document.activeElement) ? document.activeElement : candidates[0];
      options.forEach(element => {
        makeButton(element);
        set(element, 'tabindex', element === current ? '0' : '-1');
      });
      if (pendingCountry === trigger && expanded) {
        focus(search || current || trigger);
        pendingCountry = null;
      }
    });
  };
  const enhance = () => {
    const next = document.getElementById('wfq-modal');
    document.querySelectorAll(openerSelector).forEach(element => {
      makeButton(element, element.matches('.wfq-header-icon') ? strings('quoteOpen', 'Open product quote') : null);
      set(element, 'aria-haspopup', 'dialog');
      if (next) set(element, 'aria-controls', 'wfq-modal');else if (element.getAttribute('aria-controls') === 'wfq-modal') element.removeAttribute('aria-controls');
    });
    if (modal !== next && open) {
      var _modal2;
      releaseBackground();
      (_modal2 = modal) === null || _modal2 === void 0 || _modal2.removeAttribute('aria-modal');
      if (!visible(next)) release();
    }
    modal = next;
    if (!modal) return;
    set(modal, 'role', 'dialog');
    set(modal, 'aria-label', strings('quoteDialog', 'Product quote'));
    set(modal, 'tabindex', '-1');
    modal.querySelectorAll('.wfq-close').forEach(element => makeButton(element, strings('quoteClose', 'Close product quote')));
    [['.wfq-deleteIcon', 'quoteRemove', 'Remove {product} from quote'], ['.wfq-qty-minus', 'quoteDecrease', 'Decrease quantity for {product}'], ['.wfq-qty-plus', 'quoteIncrease', 'Increase quantity for {product}']].forEach(([selector, key, fallback]) => modal.querySelectorAll(selector).forEach(element => makeButton(element, strings(key, fallback, {
      product: productName(element)
    }))));
    modal.querySelectorAll('.wfq-quant-update').forEach(element => set(element, 'aria-label', strings('quoteQuantity', 'Quantity for {product}', {
      product: productName(element)
    })));
    enhanceFields();
    enhanceCountries();
    const status = liveRegion('status', 'status');
    const validation = liveRegion('validation', 'alert');
    if (!visible(modal)) {
      if (open) release();
      return;
    }
    set(modal, 'aria-modal', 'true');
    lockBackground();
    if (!document.body.classList.contains('esp-quote-open')) document.body.classList.add('esp-quote-open');
    if (!open) {
      open = true;
      if (!opener) opener = document.activeElement;
      focus(modal.querySelector('.wfq-close') || modal);
    } else if (focusRecord && (!focusRecord.element.isConnected || !modal.contains(focusRecord.element))) {
      focus(replacementFocus() || modal.querySelector('.wfq-close') || modal);
    }
    const rows = [...modal.querySelectorAll('.wfq-pro-info')];
    if (rows.every(row => {
      var _row$querySelector2;
      return !((_row$querySelector2 = row.querySelector('.wfq-quant-update')) !== null && _row$querySelector2 !== void 0 && _row$querySelector2.validity) || row.querySelector('.wfq-quant-update').validity.valid;
    })) {
      const items = rows.map(row => {
        var _row$querySelector3;
        return strings('quoteItemQuantity', '{product}, quantity {quantity}', {
          product: rowName(row),
          quantity: ((_row$querySelector3 = row.querySelector('.wfq-quant-update')) === null || _row$querySelector3 === void 0 ? void 0 : _row$querySelector3.value) || ''
        });
      });
      const nextState = items.join('; ');
      if (quoteState !== null && nextState !== quoteState) announce(status, nextState ? strings('quoteUpdated', 'Quote updated. {items}.', {
        items: nextState
      }) : strings('quoteEmpty', 'Quote is empty.'));
      quoteState = nextState;
    }
    const invalid = [...modal.querySelectorAll('[aria-invalid="true"]')].filter(visible);
    const errors = [...modal.querySelectorAll('.wfq-form-error')].filter(error => visible(error) && error.textContent.trim());
    const nextErrors = [...new Set(errors.map(error => error.textContent.trim()))].join(' ');
    const nextErrorState = {
      fields: invalid,
      count: invalid.length || errors.length,
      text: nextErrors
    };
    const errorsChanged = !errorState || errorState.text !== nextErrors || errorState.count !== nextErrorState.count || errorState.fields.length !== invalid.length || invalid.some((field, index) => field !== errorState.fields[index]);
    const submitted = validationUntil > Date.now();
    if (nextErrors && (errorsChanged || submitted)) {
      const summary = strings('quoteErrors', 'Please review the quote form.', {
        count: nextErrorState.count
      });
      announce(validation, `${summary} ${nextErrors}`, submitted);
    } else if (!nextErrors && validation.textContent) validation.textContent = '';
    errorState = nextErrorState;
    if (submitted && (invalid.length || nextErrors)) {
      validationUntil = 0;
      if (invalid.length) focus(invalid[0]);
    }
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      enhance();
    });
  };
  document.addEventListener('click', event => {
    var _event$target$closest, _event$target, _event$target$closest2, _event$target2, _event$target$closest3, _event$target3;
    const target = (_event$target$closest = (_event$target = event.target).closest) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.call(_event$target, actionSelector);
    if (target !== null && target !== void 0 && target.matches('.wfq-selected-country,.wfq-country-option') && target.closest('#wfq-modal')) {
      var _target$closest;
      const phone = (_target$closest = target.closest('label')) === null || _target$closest === void 0 ? void 0 : _target$closest.control;
      // A country action inside the Phone label must not also activate Phone,
      // which the app treats as an outside click and uses to close the picker.
      if (phone !== null && phone !== void 0 && phone.matches('input[name="phone"],input[name="billing_phone"]')) event.preventDefault();
    }
    if ((_event$target$closest2 = (_event$target2 = event.target).closest) !== null && _event$target$closest2 !== void 0 && _event$target$closest2.call(_event$target2, '#wfq-modal button[type="submit"],#wfq-modal input[type="submit"]')) validationUntil = Date.now() + 2000;
    if (target !== null && target !== void 0 && target.matches(openerSelector)) opener = target;
    if (target !== null && target !== void 0 && target.matches('.wfq-selected-country')) pendingCountry = target;
    if (target !== null && target !== void 0 && target.matches('.wfq-country-option')) {
      var _target$closest2;
      const trigger = (_target$closest2 = target.closest('.wfq-custom-dropdown')) === null || _target$closest2 === void 0 ? void 0 : _target$closest2.querySelector('.wfq-selected-country');
      requestAnimationFrame(() => {
        if (open) focus(trigger);
      });
    }
    if (target || (_event$target$closest3 = (_event$target3 = event.target).closest) !== null && _event$target$closest3 !== void 0 && _event$target$closest3.call(_event$target3, '#wfq-modal')) schedule();
  }, true);
  document.addEventListener('focusin', event => {
    if (!open || !modal || redirecting) return;
    if (modal.contains(event.target)) rememberFocus(event.target);else {
      redirecting = true;
      focus(replacementFocus() || focusable(modal)[0] || modal);
      redirecting = false;
    }
  });
  document.addEventListener('invalid', event => {
    var _event$target$closest4, _event$target4;
    if (!((_event$target$closest4 = (_event$target4 = event.target).closest) !== null && _event$target$closest4 !== void 0 && _event$target$closest4.call(_event$target4, '#wfq-modal'))) return;
    setInvalid(event.target, true);
    validationUntil = Date.now() + 2000;
    schedule();
  }, true);
  document.addEventListener('submit', event => {
    var _event$target$closest5, _event$target5;
    if ((_event$target$closest5 = (_event$target5 = event.target).closest) !== null && _event$target$closest5 !== void 0 && _event$target$closest5.call(_event$target5, '#wfq-modal')) {
      validationUntil = Date.now() + 2000;
      schedule();
    }
  }, true);
  document.addEventListener('input', event => {
    var _event$target$closest6, _event$target6;
    if (!((_event$target$closest6 = (_event$target6 = event.target).closest) !== null && _event$target$closest6 !== void 0 && _event$target$closest6.call(_event$target6, '#wfq-modal')) || event.target.matches('.wfq-quant-update')) return;
    schedule();
  });
  document.addEventListener('change', event => {
    var _event$target$closest7, _event$target7;
    if ((_event$target$closest7 = (_event$target7 = event.target).closest) !== null && _event$target$closest7 !== void 0 && _event$target$closest7.call(_event$target7, '#wfq-modal')) schedule();
  });
  document.addEventListener('keydown', event => {
    var _event$target$closest8, _event$target8, _event$target$closest9, _event$target9;
    const action = (_event$target$closest8 = (_event$target8 = event.target).closest) === null || _event$target$closest8 === void 0 ? void 0 : _event$target$closest8.call(_event$target8, actionSelector);
    const dropdown = (_event$target$closest9 = (_event$target9 = event.target).closest) === null || _event$target$closest9 === void 0 ? void 0 : _event$target$closest9.call(_event$target9, '.wfq-custom-dropdown');
    const list = dropdown === null || dropdown === void 0 ? void 0 : dropdown.querySelector('.wfq-dropdown-list');
    if (open && event.key === 'Escape') {
      var _modal$querySelector;
      event.preventDefault();
      event.stopImmediatePropagation();
      const expanded = list && visible(list) ? list : [...modal.querySelectorAll('.wfq-dropdown-list')].find(visible);
      if (expanded) {
        var _expanded$closest;
        const trigger = (_expanded$closest = expanded.closest('.wfq-custom-dropdown')) === null || _expanded$closest === void 0 ? void 0 : _expanded$closest.querySelector('.wfq-selected-country');
        // The vendor's trigger opens this list but does not toggle it closed.
        expanded.style.display = 'none';
        if (trigger) set(trigger, 'aria-expanded', 'false');
        pendingCountry = null;
        focus(trigger);
      } else (_modal$querySelector = modal.querySelector('.wfq-close')) === null || _modal$querySelector === void 0 || _modal$querySelector.click();
      schedule();
      return;
    }
    if (list && visible(list) && ['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key) && (action !== null && action !== void 0 && action.matches('.wfq-country-option') || event.key.startsWith('Arrow'))) {
      const options = [...list.querySelectorAll('.wfq-country-option')].filter(visible);
      if (options.length) {
        event.preventDefault();
        const index = options.indexOf(event.target.closest('.wfq-country-option'));
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : index < 0 ? event.key === 'ArrowDown' ? 0 : options.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
        options.forEach(element => set(element, 'tabindex', '-1'));
        set(options[next], 'tabindex', '0');
        focus(options[next]);
      }
      return;
    }
    if (action && !action.matches('button,a[href],input') && ['Enter', ' '].includes(event.key)) {
      event.preventDefault();
      if (!event.repeat && !action.disabled && action.getAttribute('aria-disabled') !== 'true') action.click();
      return;
    }
    if (open && event.key === 'Tab') {
      const targets = focusable(modal);
      const first = targets[0],
        last = targets[targets.length - 1];
      if (!first) {
        event.preventDefault();
        focus(modal);
      } else if (event.shiftKey && (document.activeElement === first || !targets.includes(document.activeElement))) {
        event.preventDefault();
        focus(last);
      } else if (!event.shiftKey && (document.activeElement === last || !targets.includes(document.activeElement))) {
        event.preventDefault();
        focus(first);
      }
    }
  }, true);
  const start = () => {
    new MutationObserver(records => {
      if (records.some(record => {
        var _record$target$closes, _record$target, _record$target$contai, _record$target2;
        return record.type === 'childList' || record.type === 'characterData' || ((_record$target$closes = (_record$target = record.target).closest) === null || _record$target$closes === void 0 ? void 0 : _record$target$closes.call(_record$target, '#wfq-modal')) || ((_record$target$contai = (_record$target2 = record.target).contains) === null || _record$target$contai === void 0 ? void 0 : _record$target$contai.call(_record$target2, modal));
      })) schedule();
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'disabled', 'value']
    });
    enhance();
  };
  if (document.body) start();else document.addEventListener('DOMContentLoaded', start, {
    once: true
  });
})();
